import PolicyLayout from "../components/PolicyLayout";
import { useEffect } from "react";

export default function PrivacyPage() {
    useEffect(() => {
        document.title = "Privatlivspolitik · Cleany.dk";
    }, []);
    return (
        <PolicyLayout title="Privatlivspolitik" lastUpdated="3. maj 2026">
            <p className="lead">
                Hos Cleany.dk tager vi databeskyttelse alvorligt. Denne politik beskriver
                hvilke personoplysninger vi indsamler, hvordan vi bruger dem, og hvilke
                rettigheder du har som registreret.
            </p>

            <h2>1. Dataansvarlig</h2>
            <p>
                Den juridiske enhed bag Cleany.dk er dataansvarlig for behandlingen af de
                personoplysninger, vi modtager.
            </p>
            <ul>
                <li>
                    <strong>Firmanavn:</strong> Cleany.dk
                </li>
                <li>
                    <strong>CVR-nr.:</strong> 45 42 27 20
                </li>
                <li>
                    <strong>Adresse:</strong> Strevelinsvej 16, 7000 Fredericia
                </li>
                <li>
                    <strong>Email:</strong>{" "}
                    <a href="mailto:info@cleany.dk">info@cleany.dk</a>
                </li>
            </ul>

            <h2>2. Hvilke personoplysninger indsamler vi?</h2>
            <p>
                Når du tilmelder dig vores venteliste eller skriver til os via
                kontaktformularen, behandler vi følgende oplysninger om dig:
            </p>
            <ul>
                <li>Fulde navn</li>
                <li>Firmanavn</li>
                <li>E-mailadresse</li>
                <li>Telefonnummer</li>
                <li>Eventuel besked du selv har skrevet til os</li>
                <li>
                    Tekniske oplysninger som IP-adresse, browsertype og tidspunkt for besøg
                    (kun ved samtykke til statistik-cookies)
                </li>
            </ul>

            <h2>3. Formål og retsgrundlag</h2>
            <p>Vi behandler dine oplysninger for at:</p>
            <ul>
                <li>
                    <strong>Administrere ventelisten</strong> og kontakte dig vedrørende
                    launch og adgang til Cleany. <em>Retsgrundlag:</em> samtykke
                    (databeskyttelsesforordningens art. 6, stk. 1, litra a).
                </li>
                <li>
                    <strong>Besvare henvendelser</strong> via kontaktformularen.{" "}
                    <em>Retsgrundlag:</em> vores legitime interesse i at kunne svare på
                    forespørgsler (art. 6, stk. 1, litra f).
                </li>
                <li>
                    <strong>Forbedre vores hjemmeside og service</strong> via anonymiseret
                    statistik. <em>Retsgrundlag:</em> samtykke (cookies).
                </li>
            </ul>

            <h2>4. Modtagere og databehandlere</h2>
            <p>
                Vi videregiver ikke dine personoplysninger til tredjeparter med
                kommercielle formål. Vi anvender følgende databehandlere, som hjælper os
                med at drive hjemmesiden og kommunikere med dig:
            </p>
            <ul>
                <li>
                    <strong>Hostingudbyder</strong> (server- og databasehosting i EU/EØS).
                </li>
                <li>
                    <strong>PostHog</strong> – analyse- og statistikværktøj (kun ved
                    samtykke).
                </li>
                <li>
                    <strong>Google (Workspace / Calendar)</strong> – mødebooking og email.
                </li>
            </ul>
            <p>
                Med alle databehandlere har vi indgået databehandleraftaler, som lever op
                til kravene i GDPR.
            </p>

            <h2>5. Overførsel til tredjelande</h2>
            <p>
                Visse af vores databehandlere (fx PostHog og Google) kan behandle data i
                lande uden for EU/EØS. Sådanne overførsler sker på baggrund af EU-Kommissionens
                standardkontraktbestemmelser eller andre lovlige overførselsgrundlag.
            </p>

            <h2>6. Opbevaringsperiode</h2>
            <ul>
                <li>
                    <strong>Venteliste-oplysninger:</strong> opbevares indtil 6 måneder
                    efter launch eller indtil du beder os om at slette dem.
                </li>
                <li>
                    <strong>Kontakthenvendelser:</strong> opbevares i op til 12 måneder
                    efter sidste korrespondance.
                </li>
                <li>
                    <strong>Statistik-data:</strong> opbevares i 14 måneder.
                </li>
            </ul>

            <h2>7. Dine rettigheder</h2>
            <p>Du har følgende rettigheder efter GDPR:</p>
            <ul>
                <li>Ret til indsigt i hvilke oplysninger vi har om dig</li>
                <li>Ret til berigtigelse af forkerte oplysninger</li>
                <li>Ret til sletning ("retten til at blive glemt")</li>
                <li>Ret til begrænsning af behandling</li>
                <li>Ret til dataportabilitet</li>
                <li>Ret til at gøre indsigelse mod behandlingen</li>
                <li>Ret til at trække dit samtykke tilbage på ethvert tidspunkt</li>
            </ul>
            <p>
                Du kan udøve dine rettigheder ved at sende en e-mail til{" "}
                <a href="mailto:info@cleany.dk">info@cleany.dk</a>. Vi besvarer
                henvendelsen inden for 30 dage.
            </p>

            <h2>8. Klage til Datatilsynet</h2>
            <p>
                Hvis du er utilfreds med vores behandling af dine personoplysninger, kan
                du klage til Datatilsynet:
            </p>
            <ul>
                <li>
                    <a href="https://www.datatilsynet.dk" target="_blank" rel="noopener noreferrer">
                        www.datatilsynet.dk
                    </a>
                </li>
                <li>Borgergade 28, 5., 1300 København K</li>
                <li>Telefon: +45 33 19 32 00</li>
            </ul>

            <h2>9. Ændringer i politikken</h2>
            <p>
                Vi kan opdatere denne privatlivspolitik fra tid til anden. Den seneste
                version vil altid være tilgængelig på denne side med dato for sidste
                opdatering øverst.
            </p>
        </PolicyLayout>
    );
}
